import Connect from './Connect';

export default Connect;
